import React from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import { brainstormProtectedRoutes } from "../../brainstormStudio";
import Dashboard from "../../pages/Dashboard";
import Skill from "../../pages/Skills";
import PlaygroundPage from "../../pages/Playground";
import AutomationPage from "../../pages/Automation";
import { ProtectedRoute } from "./ProtectedRoute";

const AuthOutlet = () => (
  <ProtectedRoute>
    <Outlet />
  </ProtectedRoute>
);

const Routing = () => {
  return (
    <Routes>
      <Route element={<AuthOutlet />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/skills" element={<Skill />} />
        <Route path="/skills/:agentName" element={<Skill />} />
        <Route path="/automation" element={<AutomationPage />} />
        <Route path="/automation/new" element={<AutomationPage />} />
        <Route
          path="/automation/:automationId/edit"
          element={<AutomationPage />}
        />
        <Route path="/playground/:documentId?" element={<PlaygroundPage />} />
        {brainstormProtectedRoutes}
      </Route>
    </Routes>
  );
};

export default Routing;
